import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from '@app/data/apollo';
import { isServer } from '@app/utils';

const ApolloIsomorphicProvider = ({ children, req }) => {
  let client;

  const { stockx_device_id, token, localization } = req || {};
  const { acceptLanguage, countryCode } = localization || {};

  if (isServer) {
    client = apolloClient(acceptLanguage, stockx_device_id, token, countryCode);
  } else {
    // create client side client with
    client = apolloClient();
  }

  const [savedClient] = React.useState(client);

  return <ApolloProvider client={savedClient}>{children}</ApolloProvider>;
};

export default ApolloIsomorphicProvider;
